<div class="card">
  <div class="card-body">
    <h5>Prescriber</h5>

    <app-prescriber-incorrect-information-prompt
      [client]="task.client"
      relatedRecordType="ClientReferralTask"
      [relatedRecordId]="task.id"
      [provider]="task.provider"
      [prescriberId]="task.prescriberId" />

    <div class="row mb-2 pe-2">
      <div class="col">
        <div><strong>PRESCRIBER</strong></div>
        <div><app-prescriber-name [provider]="task.provider" /></div>
        <br />
        <div><strong>SPECIALTY</strong></div>
        <div><app-specialty-badges [specialties]="task.provider.specialties" /></div>
      </div>
      <div class="col">
        <app-prescriber-offices-scrollable [provider]="task.provider" [acceptableFaxStatusOnly]="true" />
      </div>
    </div>
  </div>
</div>
<app-client-task-encounters [patient]="task.patient" />
<div class="card mt-2">
  <div class="card-body">
    <app-client-referral-task-related-tasks [task]="task" />
  </div>
</div>
<div class="card mt-2">
  <div class="card-body">
    <app-patient-prescriber-consult-notes
      [patient]="task.patient"
      [prescriberId]="task.prescriberId"
    />
  </div>
</div>
<ng-template #noEncounters> <p>There are no encounters.</p> </ng-template>
<ng-template #encounterSpinner> <mat-spinner [diameter]="30" /> </ng-template>
